/** Returns the sports year.
 * If the month is July or after, the next year will be the year.
 */
export const getSportsYear = (latestSeason) => {
  const currentDate = new Date()
  const currentMonth = currentDate.getMonth() + 1
  const currentYear = currentDate.getFullYear()
  const sportsYears = currentMonth <= 7 ? currentYear : currentYear + 1
  return latestSeason ? parseInt(latestSeason) : sportsYears
}